import React from 'react';
import { useBalance } from 'store/Balance/useCases';
import { translationStore } from 'store/Translations';
import classes from './Balance.scss';

export const Balance: React.FC = () => {
    const t = translationStore.useTranslate();
    const balance = useBalance();

    if (!balance) {
        return null;
    }

    return (
        <div className={classes.container} data-qa="block-balance">
            <span className={classes.label}>{t.string('amount')}</span>
            <span data-qa="title-balance-amount">{balance}</span>
        </div>
    );
};
